import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setBreadcrumb } from 'components/Navbar/modules';
import { resetAll } from 'modules/steps/actions';
import Call from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.callforImpactHall || {},
    app: state.app,
    calls: state.narratives.list,
    speedDatingMeetings: state.speedDating.meetings,
    actualUser: state.session.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Call));



// WEBPACK FOOTER //
// ./src/routes/Call/container/index.js